import React, { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import useUkm from "../../services/queries/useUkm";
import useInputPembayaran from "../../services/mutations/useInputPembayaran";
import useUser from "../../services/queries/useUser";
import toRibuan from "../../utils/toRibuan";
import defaultAxios, { AxiosError } from "axios";
import { useAuthStore } from "../../stores/authStore";
import { useTransaksiStore } from "../../stores/transaksiStore";
import { getLocalUkmId } from "../../utils/handleChangeUkmId";
import { BlobProvider, pdf } from "@react-pdf/renderer";
import { LoadingButton } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
    Box,
    Dialog,
    DialogTitle,
    Grid,
    Stack,
    Typography,
    IconButton,
    DialogContent,
    FormControlLabel,
    Checkbox,
    Button,
    Autocomplete,
    TextField,
    Chip,
    Link,
    InputAdornment,
    ToggleButtonGroup,
    ToggleButton,
    Tooltip,
} from "@mui/material";
import {
    IFaktur,
    IOptions,
    ParamsGetUkm,
    TipeStruk,
    DaftarKategoriListInvoice,
} from "../../constants/types";
import PrintStrukPdf from "../PrintStruk/PrintStrukPdf";
import { StrukData } from "../PrintStruk/strukData";
import useMetodePembayaran from "../../services/queries/useMetodePembayaran";
import ModalAlertPro from "../ModalAlertPro/ModalAlertPro";
import useFindMetodePembayaran from "../../services/queries/useFindMetodePembayaran";
import { Print } from "@mui/icons-material";
import useFindCustomStruk from "../../services/queries/useFindCustomStruk";
import { IconContext } from "react-icons";
import { GiMoneyStack, GiWallet } from "react-icons/gi";
import moment from "moment";
import PrintStrukA4 from "../PrintStrukA4/PrintStrukA4";
import truncate from "../../utils/truncate";

import useListInvoice from "../../services/queries/useListInvoice";

interface IModalKonfirmasiBayarProps {
    refetch: () => void;
    persentaseDiskon?: number | null;
    diskon?: number;
    persentasePajak?: number | null;
    pajak?: number;
    serviceCustom?: number;
    serviceCustomPersen?: number | null;
    totalTagihan: number;
    uangDibayar: number;
    kembalian: number;
    kasir: string;
    sales: IOptions | null;
    keteranganBeli: string;
    resetKeteranganBeli: () => void;
}

interface CartItem {
    namaKategori: string;
    namaBarang: string;
    harga: number;
    qty: number;
}

enum ModePembayaran {
    TUNAI = "tunai",
    TRANSFER = "transfer",
}

type ToggleKirimStruk = "email" | "whatsapp";

export const ModalKonfirmasiBayar = (props: IModalKonfirmasiBayarProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    let now = moment().format("DD MMM YYYY HH:mm");

    const ukmIdUser = useAuthStore((s) => s.ukmIdUser);
    const { data: user } = useUser();

    const initialParamsUkm = {
        size: 500,
        page: 1,
        search: "",
    };

    const [paramsUkm, setParamsUkm] =
        React.useState<ParamsGetUkm>(initialParamsUkm);
    const { data: ukm } = useUkm(paramsUkm);

    const [printStruk, setPrintStruk] = useState(false);
    const [kirimEmail, setKirimEmail] = useState(false);
    const [email, setEmail] = useState("");
    const [totalHargaSeluruhItem, setTotalHargaSeluruhItem] = useState(0);
    const inputPembayaranMutation = useInputPembayaran();
    const [toggleModePembayaran, setToggleModePembayaran] = useState(
        ModePembayaran.TUNAI,
    );
    const [selectedMetode, setSelectedMetode] = useState<IOptions | null>(null);
    const [isOpenModalAlertPro, setIsOpenModalAlertPro] = useState(false);
    const [toggleKirimStruk, setToggleKirimStruk] =
        useState<ToggleKirimStruk>("whatsapp");
    const [tipeStruk, setTipeStruk] = useState<string | null>();
    const [tipeStrukTagihan, setTipeStrukTagihan] = useState<string | null>(
        localStorage.getItem("tipeStrukInvoice") ?? TipeStruk.Mobile,
    );
    const [isIncludeDapur, setIsIncludeDapur] = useState<boolean>();

    const handleTipeStruk = (
        _event: React.MouseEvent<HTMLElement>,
        newTipeStruk: TipeStruk | null,
    ) => {
        if (newTipeStruk !== null) {
            setTipeStruk(newTipeStruk);

            const isDapur =
                newTipeStruk === TipeStruk.MobileDapur ||
                newTipeStruk === TipeStruk.Mobile80Dapur;
            setIsIncludeDapur(isDapur);
        }
    };

    const handleTipeStrukTagihan = (
        _event: React.MouseEvent<HTMLElement>,
        newTipeStruk: TipeStruk | null,
    ) => {
        if (newTipeStruk !== null) {
            setTipeStrukTagihan(newTipeStruk);
            localStorage.setItem("tipeStrukInvoice", newTipeStruk);

            const isDapur =
                newTipeStruk === TipeStruk.MobileDapur ||
                newTipeStruk === TipeStruk.Mobile80Dapur;
            setIsIncludeDapur(isDapur);
            localStorage.setItem("isIncludeDapur", String(isDapur));
        }
    };

    const pilihWhatsapp = () => {
        setToggleKirimStruk("whatsapp");
        setEmail("");
    };

    const pilihEmail = () => {
        setToggleKirimStruk("email");
        setEmail("");
    };

    const ukmId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalUkmId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const ukmData = React.useMemo(() => {
        if (ukmId) {
            return ukm?.content.find((li) => li.id === ukmId);
        }
        return ukm?.content[0];
    }, [ukm?.content, ukmId]);

    useEffect(() => {
        if (ukmData) {
            setPrintStruk(ukmData.webCetakStruk === 1);
            setTipeStrukTagihan(ukmData.webUkuranStruk);
            setTipeStruk(ukmData.webUkuranStruk);
            setKirimEmail(ukmData.webKirimStruk === 1);

            const isDapur =
                ukmData.webUkuranStruk === TipeStruk.MobileDapur ||
                ukmData.webUkuranStruk === TipeStruk.Mobile80Dapur;
            setIsIncludeDapur(isDapur);
        }
    }, [ukmData]);

    const initialParamsMetodePembayaran = {
        ukmId: ukmIdUser && ukmIdUser[0],
        size: 100,
        page: 1,
        search: "",
    };

    const { data: metodePembayaran, isLoading: isLoadingMetodePembayaran } =
        useMetodePembayaran(initialParamsMetodePembayaran);

    const {
        data: findMetodePembayaran,
        isLoading: isLoadingFindMetodePembayaran,
    } = useFindMetodePembayaran(Number(selectedMetode?.id));

    const mappedMetodePembayaran = metodePembayaran?.content?.map((li) => ({
        id: li.id,
        nama: li.namaMetode,
    }));

    const { data: findCustomStruk } = useFindCustomStruk(Number(ukmId));

    const initialParamsListInvoice = {
        ukmId: ukmIdUser && ukmIdUser[0],
        search: "",
        size: 100,
        page: 1,
        tanggalAwal: now,
        tanggalAkhir: now,
        kasir: "",
        sales: "",
        metodeId: "",
        voidInvoice: "",
    };

    const { data: listInvoice } = useListInvoice(initialParamsListInvoice);

    const transaksiKe =
        (Number(listInvoice?.content?.[0]?.transaksiKe) || 0) + 1;

    const pilihTunai = () => {
        setToggleModePembayaran(ModePembayaran.TUNAI);
    };

    const pilihTransfer = () => {
        setToggleModePembayaran(ModePembayaran.TRANSFER);
    };

    const cart = useTransaksiStore((s) => s.cart);
    const handleReset = useTransaksiStore((s) => s.handleReset);
    const totalHarga = useTransaksiStore((s) => s.totalHarga);
    const isOpenModalKonfirmasiBayar = useTransaksiStore(
        (s) => s.isOpenModalKonfirmasiBayar,
    );
    const closeModalBayar = useTransaksiStore((s) => s.closeModalBayar);
    const closeModalKonfirmasiBayar = useTransaksiStore(
        (s) => s.closeModalKonfirmasiBayar,
    );
    const checked = useTransaksiStore((s) => s.checked);
    const setChecked = useTransaksiStore((s) => s.setChecked);
    const handleIsKeterangan = useTransaksiStore((s) => s.handleIsKeterangan);
    const setFetchingItems = useTransaksiStore((s) => s.setFetchingItems);
    const handlingDonePembayaran = useTransaksiStore(
        (s) => s.handlingDonePembayaran,
    );

    const current = new Date();
    current.getSeconds();

    const handleHitungTotalHargaSeluruhItem = useCallback(() => {
        let total = 0;
        if (cart) {
            cart.forEach((list) => {
                total += list.harga * list.qty;
            });
            setTotalHargaSeluruhItem(total);
            return;
        }
    }, [cart]);

    useEffect(() => {
        handleHitungTotalHargaSeluruhItem();
    }, [cart, handleHitungTotalHargaSeluruhItem]);

    const handlePrintStruk = (checked: boolean) => {
        if (checked) {
            setPrintStruk(true);
        } else {
            setPrintStruk(false);
        }
    };

    const handleKirimEmail = (checked: boolean) => {
        if (checked) {
            setEmail("");
            setKirimEmail(true);
        } else {
            setKirimEmail(false);
        }
    };

    useEffect(() => {
        if (localStorage.getItem("printStruk") === "true") {
            setPrintStruk(true);
        } else {
            setPrintStruk(false);
        }
    }, []);

    const filterNewKodeFaktur = (idBundling: number) => {
        let kodeFakturBundling: IFaktur[] = [];
        cart.forEach((li) =>
            li.detailBundling
                .filter((fd) => fd.bundlingId === idBundling)
                .forEach((db) => {
                    if (db.newFaktur) {
                        db.newFaktur.forEach((nf) => {
                            kodeFakturBundling.push(nf);
                        });
                    }
                }),
        );
        return kodeFakturBundling.map((li) => ({
            idFaktur: li.fakturId,
            kodeFaktur: li.kodeFaktur,
            jumlahItem: li.jumlahItem,
        }));
    };

    const [groupByKategori, setGroupByKategori] = useState(false);

    const showToastError = useCallback((message: string) => {
        Swal.fire({
            title: message,
            position: "top-end",
            showConfirmButton: false,
            icon: "error",
            toast: true,
            timer: 3000,
            timerProgressBar: true,
            showCloseButton: true,
            customClass: {
                container: "my-swal",
            },
        });
    }, []);

    const handleCheckboxKategori = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setGroupByKategori(event.target.checked);
    };

    const buildStrukData = (overrides?: Partial<StrukData>): StrukData => ({
        cart,
        category: categoryData,
        total: props.totalTagihan,
        diskon: props.diskon,
        pajak: props.pajak,
        pajakPersen: ukmData?.pajak ?? null,
        serviceCustom: props.serviceCustom,
        serviceCustomPersen: ukmData?.serviceCustom ?? null,
        tunai: Number(props.uangDibayar),
        kembalian: props.kembalian,
        kasir: props.kasir,
        sales: props.sales?.nama ?? null,
        tanggalTransaksi: now,
        transaksiKe: String(transaksiKe),
        nomorInvoice: null,
        namaMetode:
            selectedMetode && toggleModePembayaran === ModePembayaran.TRANSFER
                ? selectedMetode.nama
                : "Tunai",
        noMetode: findMetodePembayaran?.noTujuan ?? null,
        namaPemegang: findMetodePembayaran?.namaPemegang ?? null,
        qr: findMetodePembayaran?.gambar ?? null,
        keterangan: props.keteranganBeli ?? null,
        ...overrides,
    });

    // const buildStrukDoc = (nomorInvoice?: string | null) => {
    //     const isMobileTipe =
    //         tipeStruk === TipeStruk.Mobile ||
    //         tipeStruk === TipeStruk.Mobile80 ||
    //         tipeStruk === TipeStruk.MobileDapur ||
    //         tipeStruk === TipeStruk.Mobile80Dapur;
    //     if (isMobileTipe) {
    //         return (
    //             <PrintStrukPdf
    //                 ukm={ukmData}
    //                 data={buildStrukData({ nomorInvoice })}
    //                 customStruk={findCustomStruk}
    //                 format={{
    //                     is80mm:
    //                         tipeStruk === TipeStruk.Mobile80 ||
    //                         tipeStruk === TipeStruk.Mobile80Dapur,
    //                     isIncludeDapur,
    //                     groupByKategori,
    //                 }}
    //             />
    //         );
    //     }
    //     return (
    //         <PrintStrukA4
    //             ukm={ukmData}
    //             data={buildStrukData({ nomorInvoice })}
    //             customStruk={findCustomStruk}
    //             format={{ groupByKategori }}
    //         />
    //     );
    // };

    const buildStrukDoc = (
        nomorInvoice?: string | null,
        transaksiKe?: string | number | null,
    ) => {
        const isMobileTipe =
            tipeStruk === TipeStruk.Mobile ||
            tipeStruk === TipeStruk.Mobile80 ||
            tipeStruk === TipeStruk.MobileDapur ||
            tipeStruk === TipeStruk.Mobile80Dapur;
        if (isMobileTipe) {
            return (
                <PrintStrukPdf
                    ukm={ukmData}
                    data={buildStrukData({
                        nomorInvoice,
                        transaksiKe:
                            transaksiKe !== null && transaksiKe !== undefined
                                ? String(transaksiKe)
                                : undefined,
                    })}
                    customStruk={findCustomStruk}
                    format={{
                        is80mm:
                            tipeStruk === TipeStruk.Mobile80 ||
                            tipeStruk === TipeStruk.Mobile80Dapur,
                        isIncludeDapur,
                        groupByKategori,
                    }}
                />
            );
        }

        return (
            <PrintStrukA4
                ukm={ukmData}
                data={buildStrukData({
                    nomorInvoice,
                    transaksiKe:
                        transaksiKe !== null && transaksiKe !== undefined
                            ? String(transaksiKe)
                            : undefined,
                })}
                customStruk={findCustomStruk}
                format={{ groupByKategori }}
            />
        );
    };

    const inputPembayaran = () => {
        const body = {
            ukmId: ukmIdUser && ukmIdUser[0],
            jenisItem: cart.map((li) => ({
                itemId: li.id,
                namaItem: li.namaBarang,
                namaKategori: li.namaKategori,
                skuItem: li.sku,
                jumlahItem: li.qty,
                hargaSatuan: li.harga,
                hargaTotal: li.harga * li.qty,
                kodeFaktur: checked
                    ? li.detailBundling.length > 0
                        ? filterNewKodeFaktur(li.id)
                        : li.faktur.map((fa) => ({
                              idFaktur: fa.fakturId,
                              kodeFaktur: fa.kodeFaktur,
                              jumlahItem: fa.jumlahItem,
                          }))
                    : null,
            })),
            userInput: `${user?.userId}`,
            sales: !!props.sales ? props.sales.id : null,
            totalHarga: totalHargaSeluruhItem,
            diskon: props.diskon,
            pajak: props.pajak,
            pajakPersen: ukmData?.pajak,
            serviceCustom: props.serviceCustom,
            serviceCustomPersen: ukmData?.serviceCustom,
            totalPembayaran: props.totalTagihan,
            uangYangDibayar: props.uangDibayar,
            kembalian: props.kembalian,
            metodeId:
                toggleModePembayaran === ModePembayaran.TUNAI
                    ? 0
                    : selectedMetode?.id,
            email: toggleKirimStruk === "email" ? email : null,
            keterangan: !!props.keteranganBeli ? props.keteranganBeli : null,
            charge: findMetodePembayaran
                ? findMetodePembayaran.charge.charge
                : null,
            tipeCharge: findMetodePembayaran
                ? findMetodePembayaran.charge.mode
                : null,
        };

        const params = { grupProduk: groupByKategori ? 1 : 0 };

        inputPembayaranMutation.mutate(
            { body: body as any, params },
            {
                onSuccess: async (data) => {
                    if (data.code === 200) {
                        console.log(
                            "Data transaksiKe:",
                            String(data.data.transaksiKe),
                        );

                        if (printStruk) {
                            try {
                                const blob = await pdf(
                                    buildStrukDoc(
                                        data.data.nomorInvoice,
                                        data.data.transaksiKe,
                                    ),
                                ).toBlob();
                                window.open(URL.createObjectURL(blob));
                            } catch (e) {
                                console.error("Gagal membuat PDF struk:", e);
                            }
                        }

                        if (kirimEmail && toggleKirimStruk === "whatsapp") {
                            window.open(
                                `https://wa.me/62${email}?text=Struk%20pembayaran%20ULO%20${data.data.nomorInvoice}%20${window.location.origin}/struk/${data.data.encrypt}`,
                                "_blank",
                            );
                        }
                        closeModalKonfirmasiBayar();
                        closeModalBayar();
                        Swal.fire({
                            title: "Transaksi berhasil!",
                            text: "Pembayaran Anda telah berhasil",
                            icon: "success",
                            confirmButtonColor: "#45A779",
                            customClass: { container: "my-swal" },
                        });

                        if (ukmData?.webUkuranStruk) {
                            setTipeStruk(ukmData.webUkuranStruk);
                        }

                        const isDapur =
                            ukmData?.webUkuranStruk === TipeStruk.MobileDapur ||
                            ukmData?.webUkuranStruk === TipeStruk.Mobile80Dapur;
                        setIsIncludeDapur(isDapur);

                        if (printStruk) {
                            localStorage.setItem("printStruk", "true");
                        } else {
                            localStorage.removeItem("printStruk");
                        }
                        setFetchingItems();
                        handleReset();
                        setChecked(false);
                        handleIsKeterangan(false);
                        props.resetKeteranganBeli();
                        handlingDonePembayaran();
                    }
                },
                onError: (error) => {
                    handleErrorResponse(error);
                },
            },
        );
    };

    const handleErrorResponse = useCallback(
        (error) => {
            if (defaultAxios.isAxiosError(error)) {
                const serverError = error as AxiosError<any>;
                if (serverError && serverError.response) {
                    closeModalKonfirmasiBayar();
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `${serverError.response.data.data}`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalBayar();
                } else {
                    closeModalKonfirmasiBayar();
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `Telah Terjadi Kesalahan`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalBayar();
                }
            }
        },
        [closeModalBayar, closeModalKonfirmasiBayar],
    );

    React.useEffect(() => {
        if (user && user?.ukmId?.length > 0) {
            setParamsUkm((prev) => ({
                ...prev,
                userId: user.ukmId[0],
            }));
        }
    }, [user]);

    const groupItemsByCategory = (items: CartItem[]) => {
        return items.reduce(
            (acc, item) => {
                if (!acc[item.namaKategori]) {
                    acc[item.namaKategori] = [];
                }
                acc[item.namaKategori].push(item);
                return acc;
            },
            {} as { [key: string]: CartItem[] },
        );
    };

    const groupedCartItems = groupItemsByCategory(cart as CartItem[]);

    const categoryData: DaftarKategoriListInvoice[] = [];

    const isPembayaranKurang =
        props.totalTagihan > 0 &&
        (props.uangDibayar === 0 || props.uangDibayar < props.totalTagihan);

    const isDiskonPersenInvalid =
        props.persentaseDiskon !== null &&
        props.persentaseDiskon !== undefined &&
        props.persentaseDiskon > 100;

    const isDiskonNominalInvalid =
        (props.persentaseDiskon === null || props.persentaseDiskon === 0) &&
        props.diskon !== undefined &&
        props.diskon !== null &&
        props.diskon >= totalHargaSeluruhItem;

    const isTransferWithoutMetode =
        toggleModePembayaran === ModePembayaran.TRANSFER &&
        selectedMetode === null;

    const isButtonDisabled = isTransferWithoutMetode;

    const validateBeforePay = () => {
        if (isPembayaranKurang) {
            showToastError("Nominal bayar belum mencukupi");
            return false;
        }

        if (isDiskonPersenInvalid) {
            showToastError("Diskon tidak boleh melebihi 100%");
            return false;
        }

        if (isDiskonNominalInvalid) {
            showToastError("Diskon tidak boleh melebihi total tagihan");
            return false;
        }

        if (checked) {
            const cartZeroFaktur = cart.filter(
                (li) =>
                    li.detailBundling.length === 0 && li.faktur.length === 0,
            );

            let countBundling = 0;
            let count = 0;

            cart.forEach((li) =>
                li.detailBundling.forEach((db) => {
                    if (db.newFaktur) {
                        countBundling++;
                    }
                    count++;
                }),
            );

            const isNotEqual = count !== countBundling;
            if (cartZeroFaktur.length > 0 || isNotEqual) {
                showToastError("Pilih faktur terlebih dahulu");
                return false;
            }
        }

        return true;
    };

    return (
        <Box position="relative">
            <Dialog
                maxWidth="xl"
                fullWidth
                fullScreen={fullScreen || isTabletScreen}
                open={isOpenModalKonfirmasiBayar}
                onClose={() => {
                    closeModalKonfirmasiBayar();
                }}
                scroll="paper"
                PaperProps={{
                    sx: {
                        borderRadius: 1,
                    },
                }}
            >
                <DialogTitle>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <IconButton onClick={closeModalKonfirmasiBayar}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="h6" fontWeight="bold">
                            Konfirmasi Pembayaran
                        </Typography>
                    </Stack>
                </DialogTitle>
                <DialogContent
                    sx={{
                        paddingLeft: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    }}
                >
                    <Stack direction={{ xs: "column-reverse", md: "row" }}>
                        <Grid
                            item
                            xs={12}
                            lg={6}
                            paddingX={3}
                            paddingBottom={4}
                            sx={{
                                overflowY: fullScreen ? "auto" : "unset",
                                height: fullScreen ? "auto" : "auto",
                            }}
                        >
                            <Box
                                padding={2}
                                border={1}
                                borderColor="#d4d4d4"
                                borderRadius={2}
                            >
                                <Typography
                                    variant="subtitle1"
                                    color="#000000"
                                    fontWeight="bold"
                                    marginBottom={2}
                                >
                                    Metode Pembayaran
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={6} md={6}>
                                        <Button
                                            fullWidth
                                            variant={
                                                toggleModePembayaran ===
                                                ModePembayaran.TUNAI
                                                    ? "contained"
                                                    : "outlined"
                                            }
                                            onClick={pilihTunai}
                                            sx={{ borderRadius: 4 }}
                                        >
                                            <Stack alignItems="center">
                                                <IconContext.Provider
                                                    value={{
                                                        size: isPhoneScreen
                                                            ? "40px"
                                                            : "56px",
                                                    }}
                                                >
                                                    <GiMoneyStack />
                                                </IconContext.Provider>
                                                Tunai
                                            </Stack>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6} md={6}>
                                        <Stack
                                            component={
                                                ukmData?.isPro === 0
                                                    ? Link
                                                    : Stack
                                            }
                                            underline="none"
                                            onClick={() => {
                                                if (ukmData?.isPro === 1) {
                                                    return;
                                                } else {
                                                    setIsOpenModalAlertPro(
                                                        true,
                                                    );
                                                }
                                            }}
                                            sx={{
                                                cursor:
                                                    ukmData?.isPro === 0
                                                        ? "pointer"
                                                        : undefined,
                                            }}
                                        >
                                            <Button
                                                fullWidth
                                                variant={
                                                    toggleModePembayaran ===
                                                    ModePembayaran.TRANSFER
                                                        ? "contained"
                                                        : "outlined"
                                                }
                                                onClick={() => {
                                                    if (ukmData?.isPro === 1) {
                                                        pilihTransfer();
                                                    }
                                                }}
                                                sx={{ borderRadius: 4 }}
                                            >
                                                <Stack alignItems="center">
                                                    <IconContext.Provider
                                                        value={{
                                                            size: isPhoneScreen
                                                                ? "40px"
                                                                : "56px",
                                                        }}
                                                    >
                                                        <GiWallet />
                                                    </IconContext.Provider>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        gap={1}
                                                    >
                                                        Metode lain{" "}
                                                        {ukmData?.isPro ===
                                                        1 ? null : (
                                                            <Chip
                                                                label="Standar"
                                                                size="small"
                                                            />
                                                        )}
                                                    </Box>
                                                </Stack>
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Box>
                            {toggleModePembayaran === ModePembayaran.TRANSFER &&
                            metodePembayaran?.content?.length !== 0 ? (
                                <Box mt={2}>
                                    <Autocomplete
                                        loading={isLoadingMetodePembayaran}
                                        options={mappedMetodePembayaran ?? []}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Pilih metode"
                                                variant="outlined"
                                            />
                                        )}
                                        getOptionLabel={(option) => option.nama}
                                        isOptionEqualToValue={(option, value) =>
                                            String(option.id) ===
                                            String(value.id)
                                        }
                                        size="small"
                                        fullWidth
                                        value={selectedMetode}
                                        onChange={(
                                            _event,
                                            newKategori: IOptions | null,
                                        ) => {
                                            setSelectedMetode(newKategori);
                                        }}
                                        sx={{ marginBottom: 2 }}
                                    />
                                    {findMetodePembayaran && (
                                        <Stack alignItems="center">
                                            {findMetodePembayaran.gambar && (
                                                <img
                                                    src={
                                                        findMetodePembayaran.gambar
                                                    }
                                                    alt="qrcode"
                                                    width={250}
                                                    height={250}
                                                />
                                            )}
                                            <Typography>
                                                a/n{" "}
                                                {
                                                    findMetodePembayaran.namaPemegang
                                                }
                                            </Typography>
                                            <Typography fontWeight="bold">
                                                {findMetodePembayaran.noTujuan}
                                            </Typography>
                                            <Stack
                                                marginTop={4}
                                                alignItems="center"
                                                spacing={2}
                                            >
                                                <Typography>
                                                    Pilih tipe struk:
                                                </Typography>
                                                <ToggleButtonGroup
                                                    value={tipeStrukTagihan}
                                                    exclusive
                                                    size="small"
                                                    onChange={
                                                        handleTipeStrukTagihan
                                                    }
                                                    sx={(theme) => ({
                                                        flexWrap: "wrap",
                                                        [theme.breakpoints.down(
                                                            "sm",
                                                        )]: {
                                                            justifyContent:
                                                                "center",
                                                            gap: 0.5,
                                                            "& .MuiToggleButtonGroup-grouped":
                                                                {
                                                                    border: "1px solid rgba(0, 0, 0, 0.12) !important",
                                                                    borderLeft:
                                                                        "1px solid rgba(0, 0, 0, 0.12) !important",
                                                                    borderRadius:
                                                                        "4px !important",
                                                                    marginLeft:
                                                                        "0 !important",
                                                                },
                                                        },
                                                    })}
                                                >
                                                    <ToggleButton
                                                        value={TipeStruk.Mobile}
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A8 58mm</b>
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={
                                                            TipeStruk.Mobile80
                                                        }
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A8 80mm</b>
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={TipeStruk.PC}
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A4</b>
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={
                                                            TipeStruk.MobileDapur
                                                        }
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A8 58mm Dapur</b>
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={
                                                            TipeStruk.Mobile80Dapur
                                                        }
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A8 80mm Dapur</b>
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                            </Stack>
                                            {tipeStrukTagihan ===
                                                TipeStruk.Mobile ||
                                            tipeStrukTagihan ===
                                                TipeStruk.Mobile80 ||
                                            tipeStrukTagihan ===
                                                TipeStruk.MobileDapur ||
                                            tipeStrukTagihan ===
                                                TipeStruk.Mobile80Dapur ? (
                                                <BlobProvider
                                                    document={
                                                        <PrintStrukPdf
                                                            ukm={ukmData}
                                                            data={buildStrukData(
                                                                {
                                                                    tunai: undefined,
                                                                    kembalian:
                                                                        undefined,
                                                                    belumLunas: true,
                                                                },
                                                            )}
                                                            customStruk={
                                                                findCustomStruk
                                                            }
                                                            format={{
                                                                is80mm:
                                                                    tipeStrukTagihan ===
                                                                        TipeStruk.Mobile80 ||
                                                                    tipeStrukTagihan ===
                                                                        TipeStruk.Mobile80Dapur,
                                                                isIncludeDapur,
                                                                groupByKategori,
                                                            }}
                                                        />
                                                    }
                                                >
                                                    {({
                                                        blob,
                                                        url,
                                                        loading,
                                                        error,
                                                    }) => {
                                                        return (
                                                            <LoadingButton
                                                                variant="outlined"
                                                                loading={
                                                                    loading
                                                                }
                                                                loadingPosition="center"
                                                                startIcon={
                                                                    <Print />
                                                                }
                                                                href={url ?? ""}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                sx={{
                                                                    marginTop: 2,
                                                                }}
                                                            >
                                                                Cetak Tagihan
                                                            </LoadingButton>
                                                        );
                                                    }}
                                                </BlobProvider>
                                            ) : (
                                                <BlobProvider
                                                    document={
                                                        <PrintStrukA4
                                                            ukm={ukmData}
                                                            data={buildStrukData(
                                                                {
                                                                    tunai: undefined,
                                                                    kembalian:
                                                                        undefined,
                                                                    belumLunas: true,
                                                                },
                                                            )}
                                                            customStruk={
                                                                findCustomStruk
                                                            }
                                                            format={{
                                                                groupByKategori,
                                                            }}
                                                        />
                                                    }
                                                >
                                                    {({
                                                        blob,
                                                        url,
                                                        loading,
                                                        error,
                                                    }) => {
                                                        return (
                                                            <LoadingButton
                                                                variant="outlined"
                                                                loading={
                                                                    loading
                                                                }
                                                                loadingPosition="center"
                                                                startIcon={
                                                                    <Print />
                                                                }
                                                                href={url ?? ""}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                sx={{
                                                                    marginTop: 2,
                                                                }}
                                                            >
                                                                Cetak Tagihan
                                                            </LoadingButton>
                                                        );
                                                    }}
                                                </BlobProvider>
                                            )}
                                        </Stack>
                                    )}
                                </Box>
                            ) : (
                                toggleModePembayaran ===
                                    ModePembayaran.TRANSFER &&
                                metodePembayaran?.content?.length === 0 && (
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        justifyContent="flex-end"
                                        height="50%"
                                        paddingX={isPhoneScreen ? undefined : 2}
                                    >
                                        <Typography textAlign="center">
                                            Tambahkan Bank Transfer, e-Money,
                                            QRIS, dan lain-lain sebagai metode
                                            alternatif transaksi UKM Anda.
                                        </Typography>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            marginTop={4}
                                        >
                                            <Typography
                                                variant="body2"
                                                textAlign="center"
                                            >
                                                Metode lain dapat diatur di
                                                juragan.ukmlokal.com
                                            </Typography>
                                        </Box>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            marginTop={2}
                                        >
                                            <Button
                                                variant="outlined"
                                                href={
                                                    process.env.NODE_ENV ===
                                                    "production"
                                                        ? `https://juragan.ukmlokal.com/ukm/metode-pembayaran`
                                                        : `http://localhost:3000/ukm/metode-pembayaran`
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Ke Juragan
                                            </Button>
                                        </Box>
                                    </Box>
                                )
                            )}
                        </Grid>

                        {/* Bagian Kanan - Detail Transaksi */}
                        <Grid
                            item
                            xs={12}
                            lg={6}
                            borderLeft="1px solid #d4d4d4"
                            borderRadius="10px"
                        >
                            <Box
                                display="grid"
                                gridTemplateRows="auto auto 1fr auto"
                                height={
                                    fullScreen
                                        ? undefined
                                        : isTabletScreen
                                          ? "calc(100vh - 72px)"
                                          : "calc(90vh - 72px)"
                                }
                            >
                                <Stack
                                    direction="row"
                                    paddingLeft={3}
                                    paddingRight={4}
                                    paddingY={2}
                                    borderBottom="1px solid #d4d4d4"
                                    borderTop="1px solid #d4d4d4"
                                    borderRadius="10px 0 0 0"
                                >
                                    <Grid container spacing={2}>
                                        <Grid item>
                                            <Typography
                                                variant="subtitle2"
                                                color="#A1A1AA"
                                            >
                                                Tanggal
                                            </Typography>
                                            <Typography
                                                variant="subtitle2"
                                                color="black"
                                            >
                                                {now}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography
                                                variant="subtitle2"
                                                color="#A1A1AA"
                                            >
                                                Nama Kasir
                                            </Typography>
                                            <Typography
                                                variant="subtitle2"
                                                color="black"
                                            >
                                                {user?.namaLengkap}
                                            </Typography>
                                        </Grid>
                                        {!!props.sales && (
                                            <Grid item>
                                                <Typography
                                                    variant="subtitle2"
                                                    color="#A1A1AA"
                                                >
                                                    Nama Sales
                                                </Typography>
                                                <Typography
                                                    variant="subtitle2"
                                                    color="black"
                                                >
                                                    {props.sales.nama}
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Stack>

                                <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    marginTop={1}
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={groupByKategori}
                                                onChange={
                                                    handleCheckboxKategori
                                                }
                                            />
                                        }
                                        label="Group by Kategori"
                                        sx={{ height: "fit-content" }}
                                    />
                                </Box>

                                <DialogContent
                                    sx={{
                                        paddingBottom: 2,
                                    }}
                                >
                                    {groupByKategori ? (
                                        <Stack direction="column" spacing={1}>
                                            {cart && cart.length > 0 ? (
                                                Object.entries(
                                                    groupedCartItems,
                                                ).map(
                                                    (
                                                        [category, items],
                                                        idx,
                                                    ) => (
                                                        <Box key={String(idx)}>
                                                            <Stack
                                                                marginTop={2}
                                                                marginBottom={1}
                                                            >
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    fontWeight="700"
                                                                    fontSize={
                                                                        18
                                                                    }
                                                                >
                                                                    {truncate(
                                                                        category,
                                                                        20,
                                                                    )}
                                                                </Typography>
                                                            </Stack>
                                                            {items.map(
                                                                (
                                                                    rows,
                                                                    itemIdx,
                                                                ) => (
                                                                    <Stack
                                                                        key={String(
                                                                            itemIdx,
                                                                        )}
                                                                        direction="row"
                                                                        justifyContent="space-between"
                                                                        marginLeft={
                                                                            2
                                                                        }
                                                                    >
                                                                        <Box width="50%">
                                                                            <Box>
                                                                                <Tooltip
                                                                                    title={
                                                                                        rows.namaBarang
                                                                                    }
                                                                                >
                                                                                    <Typography
                                                                                        variant={
                                                                                            isTabletScreen
                                                                                                ? "body2"
                                                                                                : "subtitle1"
                                                                                        }
                                                                                        fontWeight={
                                                                                            600
                                                                                        }
                                                                                        color="black"
                                                                                    >
                                                                                        {truncate(
                                                                                            rows.namaBarang,
                                                                                            20,
                                                                                        )}
                                                                                    </Typography>
                                                                                </Tooltip>
                                                                                <Typography>
                                                                                    Rp.{" "}
                                                                                    {toRibuan(
                                                                                        rows.harga,
                                                                                    )}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                        <Box display="flex">
                                                                            <Typography
                                                                                variant={
                                                                                    isTabletScreen
                                                                                        ? "body2"
                                                                                        : "subtitle1"
                                                                                }
                                                                                fontWeight={
                                                                                    600
                                                                                }
                                                                                color="black"
                                                                            >
                                                                                {
                                                                                    rows.qty
                                                                                }

                                                                                x
                                                                            </Typography>
                                                                        </Box>
                                                                        <Stack
                                                                            direction="row"
                                                                            width="30%"
                                                                            display="flex"
                                                                            justifyContent="flex-end"
                                                                        >
                                                                            <Typography
                                                                                display="flex"
                                                                                variant={
                                                                                    isTabletScreen
                                                                                        ? "body2"
                                                                                        : "subtitle1"
                                                                                }
                                                                                fontWeight={
                                                                                    600
                                                                                }
                                                                                color="black"
                                                                                textAlign="end"
                                                                            >
                                                                                Rp.{" "}
                                                                                {toRibuan(
                                                                                    rows.harga *
                                                                                        rows.qty,
                                                                                )}
                                                                            </Typography>
                                                                        </Stack>
                                                                    </Stack>
                                                                ),
                                                            )}
                                                        </Box>
                                                    ),
                                                )
                                            ) : (
                                                <Typography variant="h6">
                                                    Barang tidak ditemukan
                                                </Typography>
                                            )}
                                        </Stack>
                                    ) : (
                                        <Stack direction="column" spacing={1}>
                                            {cart ? (
                                                cart.map((rows, idx) => (
                                                    <Box key={String(idx)}>
                                                        <Stack
                                                            direction="row"
                                                            justifyContent="space-between"
                                                        >
                                                            <Box width="50%">
                                                                <Box>
                                                                    <Tooltip
                                                                        title={
                                                                            rows.namaBarang
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            variant={
                                                                                isTabletScreen
                                                                                    ? "body2"
                                                                                    : "subtitle1"
                                                                            }
                                                                            fontWeight={
                                                                                600
                                                                            }
                                                                            color="black"
                                                                        >
                                                                            {truncate(
                                                                                rows.namaBarang,
                                                                                20,
                                                                            )}
                                                                        </Typography>
                                                                    </Tooltip>
                                                                    <Typography>
                                                                        Rp.{" "}
                                                                        {toRibuan(
                                                                            rows.harga,
                                                                        )}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            <Box display="flex">
                                                                <Typography
                                                                    variant={
                                                                        isTabletScreen
                                                                            ? "body2"
                                                                            : "subtitle1"
                                                                    }
                                                                    fontWeight={
                                                                        600
                                                                    }
                                                                    color="black"
                                                                >
                                                                    {rows.qty}x
                                                                </Typography>
                                                            </Box>
                                                            <Stack
                                                                direction="row"
                                                                width="30%"
                                                                display="flex"
                                                                justifyContent="flex-end"
                                                            >
                                                                <Typography
                                                                    display="flex"
                                                                    variant={
                                                                        isTabletScreen
                                                                            ? "body2"
                                                                            : "subtitle1"
                                                                    }
                                                                    fontWeight={
                                                                        600
                                                                    }
                                                                    color="black"
                                                                    textAlign="end"
                                                                >
                                                                    Rp.{" "}
                                                                    {toRibuan(
                                                                        rows.harga *
                                                                            rows.qty,
                                                                    )}
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    </Box>
                                                ))
                                            ) : (
                                                <Typography variant="h6">
                                                    Barang tidak ditemukan
                                                </Typography>
                                            )}
                                        </Stack>
                                    )}

                                    <Box
                                        marginY={2}
                                        padding={2}
                                        border={1}
                                        borderColor="#d4d4d4"
                                        borderRadius={2}
                                    >
                                        <Typography
                                            marginBottom={1}
                                            variant={
                                                isTabletScreen
                                                    ? "body2"
                                                    : "subtitle1"
                                            }
                                            color="#000000"
                                            fontWeight="bold"
                                        >
                                            Ringkasan Pembayaran
                                        </Typography>
                                        <Grid
                                            container
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={3}
                                                md={4}
                                                lg={4}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Subtotal Harga
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(totalHarga)}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={4}
                                                md={5}
                                                lg={5}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Diskon{" "}
                                                    {props.persentaseDiskon &&
                                                    props.persentaseDiskon > 0
                                                        ? `(${props.persentaseDiskon}%)`
                                                        : ""}
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FFF5EC"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        (Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            props.diskon ?? 0,
                                                        )}
                                                        )
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={4}
                                                md={5}
                                                lg={5}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Pajak{" "}
                                                    {props.persentasePajak &&
                                                    props.persentasePajak > 0
                                                        ? `(${props.persentasePajak}%)`
                                                        : ""}
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FFF5EC"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            props.pajak ?? 0,
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={4}
                                                md={5}
                                                lg={5}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Service{" "}
                                                    {ukmData?.serviceCustom &&
                                                    ukmData?.serviceCustom > 0
                                                        ? `(${ukmData?.serviceCustom}%)`
                                                        : ""}
                                                </Typography>
                                            </Grid>

                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FFF5EC"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            props.serviceCustom ??
                                                                0,
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            alignItems="center"
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={3}
                                                md={4}
                                                lg={4}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Total Tagihan
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#E8F6ED"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#45A779"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#45A779"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            props.totalTagihan,
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            alignItems="center"
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={3}
                                                md={4}
                                                lg={4}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Uang yang Dibayar
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FFF5EC"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#FB923C"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            props.uangDibayar ??
                                                                0,
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            alignItems="center"
                                            marginTop={1}
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={6}
                                                sm={3}
                                                md={4}
                                                lg={4}
                                            >
                                                <Typography
                                                    variant={
                                                        isTabletScreen
                                                            ? "body2"
                                                            : "subtitle1"
                                                    }
                                                    color="#404040"
                                                >
                                                    Kembalian
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={3} xs={5}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    bgcolor="#FCEAEA"
                                                    paddingX={1}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#DC2626"
                                                        fontWeight="bold"
                                                    >
                                                        Rp.
                                                    </Typography>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#DC2626"
                                                        fontWeight="bold"
                                                    >
                                                        {toRibuan(
                                                            props.kembalian,
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        {findMetodePembayaran && (
                                            <Grid
                                                container
                                                alignItems="center"
                                                marginTop={1}
                                                justifyContent="space-between"
                                            >
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sm={3}
                                                    md={4}
                                                    lg={4}
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#404040"
                                                    >
                                                        Charge{" "}
                                                        {
                                                            findMetodePembayaran.namaMetode
                                                        }{" "}
                                                        {findMetodePembayaran
                                                            .charge.mode ===
                                                        "persen"
                                                            ? `(${findMetodePembayaran.charge.charge}%)`
                                                            : ""}
                                                    </Typography>
                                                </Grid>
                                                <Grid item lg={3} xs={5}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        paddingX={1}
                                                    >
                                                        <Typography
                                                            variant={
                                                                isTabletScreen
                                                                    ? "body2"
                                                                    : "subtitle1"
                                                            }
                                                            fontWeight="bold"
                                                        >
                                                            Rp.
                                                        </Typography>
                                                        <Typography
                                                            variant={
                                                                isTabletScreen
                                                                    ? "body2"
                                                                    : "subtitle1"
                                                            }
                                                            fontWeight="bold"
                                                        >
                                                            {findMetodePembayaran
                                                                .charge.mode ===
                                                            "persen"
                                                                ? toRibuan(
                                                                      (props.uangDibayar *
                                                                          Number(
                                                                              findMetodePembayaran
                                                                                  .charge
                                                                                  .charge,
                                                                          )) /
                                                                          100,
                                                                  )
                                                                : toRibuan(
                                                                      findMetodePembayaran
                                                                          .charge
                                                                          .charge,
                                                                  )}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        )}
                                        {props.keteranganBeli && (
                                            <Grid
                                                container
                                                alignItems="center"
                                                marginTop={1}
                                            >
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        color="#404040"
                                                    >
                                                        Keterangan
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        disabled
                                                        multiline
                                                        rows={2}
                                                        fullWidth
                                                        value={
                                                            props.keteranganBeli
                                                        }
                                                        sx={{
                                                            "& .MuiOutlinedInput-input.Mui-disabled":
                                                                {
                                                                    color: "rgba(0, 0, 0, 0.87)",
                                                                    WebkitTextFillColor:
                                                                        "rgba(0, 0, 0, 0.87)",
                                                                },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Box>
                                </DialogContent>

                                {/* Bagian bawah - Print, Kirim, dan Tombol Bayar (untuk layar sedang ke atas) */}
                                <Grid
                                    container
                                    justifyContent="flex-end"
                                    display={fullScreen ? "none" : undefined}
                                >
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <Box
                                            paddingTop={3}
                                            paddingLeft={3}
                                            display="flex"
                                            flexDirection="column"
                                            justifyContent="flex-start"
                                            borderTop={1}
                                            borderColor="#d4d4d4"
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={printStruk}
                                                        size={
                                                            isTabletScreen
                                                                ? "small"
                                                                : undefined
                                                        }
                                                        onChange={(
                                                            _,
                                                            checked,
                                                        ) => {
                                                            handlePrintStruk(
                                                                checked,
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="Print struk"
                                                componentsProps={{
                                                    typography: {
                                                        fontSize: isTabletScreen
                                                            ? "12px"
                                                            : undefined,
                                                    },
                                                }}
                                                sx={{
                                                    height: "fit-content",
                                                }}
                                            />
                                            {printStruk && (
                                                <ToggleButtonGroup
                                                    value={tipeStruk}
                                                    exclusive
                                                    size="small"
                                                    onChange={handleTipeStruk}
                                                    sx={(theme) => ({
                                                        flexWrap: "wrap",
                                                        [theme.breakpoints.down(
                                                            "sm",
                                                        )]: {
                                                            justifyContent:
                                                                "center",
                                                            gap: 0.5,
                                                            "& .MuiToggleButtonGroup-grouped":
                                                                {
                                                                    border: "1px solid rgba(0, 0, 0, 0.12) !important",
                                                                    borderLeft:
                                                                        "1px solid rgba(0, 0, 0, 0.12) !important",
                                                                    borderRadius:
                                                                        "4px !important",
                                                                    marginLeft:
                                                                        "0 !important",
                                                                },
                                                        },
                                                    })}
                                                >
                                                    <ToggleButton
                                                        value={TipeStruk.Mobile}
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A8 58mm</b>
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={
                                                            TipeStruk.Mobile80
                                                        }
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A8 80mm</b>
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={TipeStruk.PC}
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A4</b>
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={
                                                            TipeStruk.MobileDapur
                                                        }
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A8 58mm Dapur</b>
                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value={
                                                            TipeStruk.Mobile80Dapur
                                                        }
                                                        sx={{
                                                            display: "flex",
                                                            paddingX: 2,
                                                            textTransform:
                                                                "none",
                                                        }}
                                                    >
                                                        <b>A8 80mm Dapur</b>
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                            )}
                                        </Box>
                                        <Box paddingLeft={3} display="flex">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={kirimEmail}
                                                        size={
                                                            isTabletScreen
                                                                ? "small"
                                                                : undefined
                                                        }
                                                        onChange={(
                                                            _,
                                                            checked,
                                                        ) => {
                                                            handleKirimEmail(
                                                                checked,
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="Kirim struk"
                                                componentsProps={{
                                                    typography: {
                                                        fontSize: isTabletScreen
                                                            ? "12px"
                                                            : undefined,
                                                    },
                                                }}
                                                sx={{
                                                    height: "fit-content",
                                                }}
                                            />
                                        </Box>
                                        {kirimEmail && (
                                            <Box paddingX={3}>
                                                <Grid container>
                                                    <Grid item xs={12} sm={6}>
                                                        <Stack
                                                            display="flex"
                                                            direction="row"
                                                            spacing={1}
                                                            sx={{
                                                                marginRight: 2,
                                                            }}
                                                        >
                                                            <Button
                                                                disabled={
                                                                    user &&
                                                                    !user.akses.transaksi.includes(
                                                                        12,
                                                                    )
                                                                }
                                                                size={
                                                                    isTabletScreen
                                                                        ? "small"
                                                                        : "medium"
                                                                }
                                                                fullWidth
                                                                variant={
                                                                    toggleKirimStruk ===
                                                                    "whatsapp"
                                                                        ? "contained"
                                                                        : "outlined"
                                                                }
                                                                onClick={() =>
                                                                    pilihWhatsapp()
                                                                }
                                                            >
                                                                Whatsapp
                                                            </Button>
                                                            <Button
                                                                disabled={
                                                                    user &&
                                                                    !user.akses.transaksi.includes(
                                                                        12,
                                                                    )
                                                                }
                                                                size={
                                                                    isTabletScreen
                                                                        ? "small"
                                                                        : "medium"
                                                                }
                                                                fullWidth
                                                                variant={
                                                                    toggleKirimStruk ===
                                                                    "email"
                                                                        ? "contained"
                                                                        : "outlined"
                                                                }
                                                                onClick={() =>
                                                                    pilihEmail()
                                                                }
                                                            >
                                                                Email
                                                            </Button>
                                                        </Stack>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            value={email}
                                                            size="small"
                                                            type="email"
                                                            fullWidth
                                                            sx={{
                                                                maxWidth: 300,
                                                            }}
                                                            placeholder={
                                                                toggleKirimStruk ===
                                                                "email"
                                                                    ? "Contoh: budi93@gmail.com"
                                                                    : "8316352725"
                                                            }
                                                            InputProps={{
                                                                startAdornment:
                                                                    toggleKirimStruk ===
                                                                        "whatsapp" && (
                                                                        <InputAdornment position="start">
                                                                            +62
                                                                        </InputAdornment>
                                                                    ),
                                                            }}
                                                            onChange={(
                                                                event: React.ChangeEvent<HTMLInputElement>,
                                                            ) =>
                                                                setEmail(
                                                                    event.target
                                                                        .value,
                                                                )
                                                            }
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        )}
                                        <Box
                                            marginTop={isTabletScreen ? 1 : 2}
                                            marginLeft={3}
                                            marginRight={3}
                                            marginBottom={
                                                isTabletScreen ? 2 : 4
                                            }
                                        >
                                            <Stack
                                                direction="column"
                                                display="flex"
                                                justifyContent="space-between"
                                                marginBottom={1}
                                                spacing={1}
                                            >
                                                <Stack
                                                    direction="row"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        fontWeight="bold"
                                                    >
                                                        Total
                                                    </Typography>
                                                    <Box
                                                        bgcolor="#E8F6ED"
                                                        borderRadius={1}
                                                        paddingX={2}
                                                    >
                                                        <Typography
                                                            variant={
                                                                isTabletScreen
                                                                    ? "body2"
                                                                    : "subtitle1"
                                                            }
                                                            fontWeight="bold"
                                                            color="#45A779"
                                                        >
                                                            Rp.{" "}
                                                            {toRibuan(
                                                                props.totalTagihan,
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                                <Stack
                                                    direction="row"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                >
                                                    <Typography
                                                        variant={
                                                            isTabletScreen
                                                                ? "body2"
                                                                : "subtitle1"
                                                        }
                                                        fontWeight="bold"
                                                    >
                                                        Kembalian
                                                    </Typography>
                                                    <Box
                                                        justifyContent="space-between"
                                                        bgcolor="#FCEAEA"
                                                        paddingX={2}
                                                        borderRadius={1}
                                                    >
                                                        <Typography
                                                            variant={
                                                                isTabletScreen
                                                                    ? "body2"
                                                                    : "subtitle1"
                                                            }
                                                            fontWeight="bold"
                                                            color="#DC2626"
                                                        >
                                                            Rp.{" "}
                                                            {toRibuan(
                                                                props.kembalian,
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                                {printStruk ? (
                                                    <BlobProvider
                                                        document={
                                                            tipeStruk ===
                                                                TipeStruk.Mobile ||
                                                            tipeStruk ===
                                                                TipeStruk.Mobile80 ||
                                                            tipeStruk ===
                                                                TipeStruk.MobileDapur ||
                                                            tipeStruk ===
                                                                TipeStruk.Mobile80Dapur ? (
                                                                <PrintStrukPdf
                                                                    ukm={
                                                                        ukmData
                                                                    }
                                                                    data={buildStrukData()}
                                                                    customStruk={
                                                                        findCustomStruk
                                                                    }
                                                                    format={{
                                                                        is80mm:
                                                                            tipeStruk ===
                                                                                TipeStruk.Mobile80 ||
                                                                            tipeStruk ===
                                                                                TipeStruk.Mobile80Dapur,
                                                                        isIncludeDapur,
                                                                        groupByKategori,
                                                                    }}
                                                                />
                                                            ) : (
                                                                <PrintStrukA4
                                                                    ukm={
                                                                        ukmData
                                                                    }
                                                                    data={buildStrukData()}
                                                                    customStruk={
                                                                        findCustomStruk
                                                                    }
                                                                    format={{
                                                                        groupByKategori,
                                                                    }}
                                                                />
                                                            )
                                                        }
                                                    >
                                                        {({
                                                            blob,
                                                            url,
                                                            loading,
                                                            error,
                                                        }) => {
                                                            return (
                                                                <LoadingButton
                                                                    disabled={
                                                                        toggleModePembayaran ===
                                                                            ModePembayaran.TRANSFER &&
                                                                        selectedMetode ===
                                                                            null
                                                                    }
                                                                    loading={
                                                                        loading ||
                                                                        inputPembayaranMutation.isLoading ||
                                                                        isLoadingFindMetodePembayaran
                                                                    }
                                                                    loadingPosition="center"
                                                                    variant="contained"
                                                                    fullWidth
                                                                    size={
                                                                        isTabletScreen
                                                                            ? "medium"
                                                                            : "large"
                                                                    }
                                                                    onClick={() =>
                                                                        inputPembayaran()
                                                                    }
                                                                >
                                                                    Bayar
                                                                </LoadingButton>
                                                            );
                                                        }}
                                                    </BlobProvider>
                                                ) : (
                                                    <LoadingButton
                                                        disabled={
                                                            toggleModePembayaran ===
                                                                ModePembayaran.TRANSFER &&
                                                            selectedMetode ===
                                                                null
                                                        }
                                                        loading={
                                                            inputPembayaranMutation.isLoading ||
                                                            isLoadingFindMetodePembayaran
                                                        }
                                                        loadingPosition="center"
                                                        variant="contained"
                                                        fullWidth
                                                        size={
                                                            isTabletScreen
                                                                ? "medium"
                                                                : "large"
                                                        }
                                                        onClick={() =>
                                                            inputPembayaran()
                                                        }
                                                    >
                                                        Bayar
                                                    </LoadingButton>
                                                )}
                                            </Stack>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Stack>

                    {/* Tombol Bayar untuk layar HP (sticky di bawah) */}
                    <Box
                        sx={{
                            display: { xs: "block", md: "none" },
                            position: "sticky",
                            bottom: 0,
                            bgcolor: "#fff",
                            pt: 2,
                            pb: 3,
                            px: 3,
                            borderTop: "1px solid #d4d4d4",
                            zIndex: 10,
                        }}
                    >
                        <Stack spacing={1}>
                            {/* Print & Kirim checkbox untuk HP */}
                            <Stack direction="row" spacing={2}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={printStruk}
                                            onChange={(_, checked) => {
                                                handlePrintStruk(checked);
                                            }}
                                        />
                                    }
                                    label="Print struk"
                                    sx={{ height: "fit-content" }}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={kirimEmail}
                                            onChange={(_, checked) => {
                                                handleKirimEmail(checked);
                                            }}
                                        />
                                    }
                                    label="Kirim struk"
                                    sx={{ height: "fit-content" }}
                                />
                            </Stack>

                            {printStruk && (
                                <ToggleButtonGroup
                                    value={tipeStruk}
                                    exclusive
                                    size="small"
                                    onChange={handleTipeStruk}
                                    sx={(theme) => ({
                                        flexWrap: "wrap",
                                        [theme.breakpoints.down("sm")]: {
                                            justifyContent: "center",
                                            gap: 0.5,
                                            "& .MuiToggleButtonGroup-grouped": {
                                                border: "1px solid rgba(0, 0, 0, 0.12) !important",
                                                borderLeft:
                                                    "1px solid rgba(0, 0, 0, 0.12) !important",
                                                borderRadius: "4px !important",
                                                marginLeft: "0 !important",
                                            },
                                        },
                                    })}
                                >
                                    <ToggleButton
                                        value={TipeStruk.Mobile}
                                        sx={{
                                            display: "flex",
                                            paddingX: 2,
                                            textTransform: "none",
                                        }}
                                    >
                                        <b>A8 58mm</b>
                                    </ToggleButton>
                                    <ToggleButton
                                        value={TipeStruk.Mobile80}
                                        sx={{
                                            display: "flex",
                                            paddingX: 2,
                                            textTransform: "none",
                                        }}
                                    >
                                        <b>A8 80mm</b>
                                    </ToggleButton>
                                    <ToggleButton
                                        value={TipeStruk.PC}
                                        sx={{
                                            display: "flex",
                                            paddingX: 2,
                                            textTransform: "none",
                                        }}
                                    >
                                        <b>A4</b>
                                    </ToggleButton>
                                    <ToggleButton
                                        value={TipeStruk.MobileDapur}
                                        sx={{
                                            display: "flex",
                                            paddingX: 2,
                                            textTransform: "none",
                                        }}
                                    >
                                        <b>A8 58mm Dapur</b>
                                    </ToggleButton>
                                    <ToggleButton
                                        value={TipeStruk.Mobile80Dapur}
                                        sx={{
                                            display: "flex",
                                            paddingX: 2,
                                            textTransform: "none",
                                        }}
                                    >
                                        <b>A8 80mm Dapur</b>
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            )}

                            {kirimEmail && (
                                <Box>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <Stack direction="row" spacing={1}>
                                                <Button
                                                    disabled={
                                                        user &&
                                                        !user.akses.transaksi.includes(
                                                            12,
                                                        )
                                                    }
                                                    size="small"
                                                    fullWidth
                                                    variant={
                                                        toggleKirimStruk ===
                                                        "whatsapp"
                                                            ? "contained"
                                                            : "outlined"
                                                    }
                                                    onClick={() =>
                                                        pilihWhatsapp()
                                                    }
                                                >
                                                    Whatsapp
                                                </Button>
                                                <Button
                                                    disabled={
                                                        user &&
                                                        !user.akses.transaksi.includes(
                                                            12,
                                                        )
                                                    }
                                                    size="small"
                                                    fullWidth
                                                    variant={
                                                        toggleKirimStruk ===
                                                        "email"
                                                            ? "contained"
                                                            : "outlined"
                                                    }
                                                    onClick={() => pilihEmail()}
                                                >
                                                    Email
                                                </Button>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={email}
                                                size="small"
                                                type="email"
                                                fullWidth
                                                placeholder={
                                                    toggleKirimStruk === "email"
                                                        ? "Contoh: budi93@gmail.com"
                                                        : "8316352725"
                                                }
                                                InputProps={{
                                                    startAdornment:
                                                        toggleKirimStruk ===
                                                            "whatsapp" && (
                                                            <InputAdornment position="start">
                                                                +62
                                                            </InputAdornment>
                                                        ),
                                                }}
                                                onChange={(
                                                    event: React.ChangeEvent<HTMLInputElement>,
                                                ) =>
                                                    setEmail(event.target.value)
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}

                            <Stack
                                direction="row"
                                justifyContent="space-between"
                            >
                                <Typography fontWeight="bold">Total</Typography>
                                <Box bgcolor="#E8F6ED" borderRadius={1} px={2}>
                                    <Typography
                                        fontWeight="bold"
                                        color="#45A779"
                                    >
                                        Rp. {toRibuan(props.totalTagihan)}
                                    </Typography>
                                </Box>
                            </Stack>
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                            >
                                <Typography fontWeight="bold">
                                    Kembalian
                                </Typography>
                                <Box bgcolor="#FCEAEA" borderRadius={1} px={2}>
                                    <Typography
                                        fontWeight="bold"
                                        color="#DC2626"
                                    >
                                        Rp. {toRibuan(props.kembalian)}
                                    </Typography>
                                </Box>
                            </Stack>
                            {printStruk ? (
                                <BlobProvider
                                    document={
                                        tipeStruk === TipeStruk.Mobile ||
                                        tipeStruk === TipeStruk.Mobile80 ||
                                        tipeStruk === TipeStruk.MobileDapur ||
                                        tipeStruk ===
                                            TipeStruk.Mobile80Dapur ? (
                                            <PrintStrukPdf
                                                ukm={ukmData}
                                                data={buildStrukData({
                                                    namaMetode: selectedMetode
                                                        ? selectedMetode.nama
                                                        : "Tunai",
                                                })}
                                                customStruk={findCustomStruk}
                                                format={{
                                                    is80mm:
                                                        tipeStruk ===
                                                            TipeStruk.Mobile80 ||
                                                        tipeStruk ===
                                                            TipeStruk.Mobile80Dapur,
                                                    isIncludeDapur,
                                                    groupByKategori,
                                                }}
                                            />
                                        ) : (
                                            <PrintStrukA4
                                                ukm={ukmData}
                                                data={buildStrukData()}
                                                customStruk={findCustomStruk}
                                                format={{
                                                    groupByKategori,
                                                }}
                                            />
                                        )
                                    }
                                >
                                    {({ blob, url, loading, error }) => {
                                        return (
                                            <LoadingButton
                                                disabled={isButtonDisabled}
                                                loading={
                                                    loading ||
                                                    inputPembayaranMutation.isLoading ||
                                                    isLoadingFindMetodePembayaran
                                                }
                                                loadingPosition="center"
                                                variant="contained"
                                                fullWidth
                                                size="large"
                                                onClick={() => {
                                                    if (!validateBeforePay()) {
                                                        return;
                                                    }
                                                    inputPembayaran();
                                                }}
                                            >
                                                Bayar
                                            </LoadingButton>
                                        );
                                    }}
                                </BlobProvider>
                            ) : (
                                <LoadingButton
                                    disabled={isButtonDisabled}
                                    loading={
                                        inputPembayaranMutation.isLoading ||
                                        isLoadingFindMetodePembayaran
                                    }
                                    loadingPosition="center"
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    onClick={() => {
                                        if (!validateBeforePay()) {
                                            return;
                                        }
                                        inputPembayaran();
                                    }}
                                >
                                    Bayar
                                </LoadingButton>
                            )}
                        </Stack>
                    </Box>
                </DialogContent>
            </Dialog>
            {ukmData && (
                <ModalAlertPro
                    isOpenModalAlertPro={isOpenModalAlertPro}
                    closeModalAlertPro={() => setIsOpenModalAlertPro(false)}
                    dataUkm={{ id: ukmData?.id, nama: ukmData?.namaToko }}
                />
            )}
        </Box>
    );
};

export default ModalKonfirmasiBayar;
